module.exports = __webpack_public_path__ + "img/34ba12e.webp";